import { Inject, Injectable, Optional } from '@angular/core';
import { SelectItem } from '@psei/ng/api';
import { AccountInvitationStatus, AccountStatusEnum } from '../models/account.model';
import { DictionaryCategory, DictionaryModel, SimpleDictionaryModel } from '../models/dictionary.model';
import { ProposalStatusTypeEnum } from '../models/proposal.model';
import { DictionaryService } from './dictionary.service';
import { MultiLangDictService, USE_MULTI_LANG_DICT } from './multi-lang-dict.service';

@Injectable({
  providedIn: 'root'
})
export class SelectItemService {

  constructor(
    @Optional() @Inject(USE_MULTI_LANG_DICT) private useMultiLangDict: boolean,
    private oldDictionaryService: DictionaryService,
    private dictionaryService: MultiLangDictService
  ) {
  }

  getAccountStatusItems(): SelectItem[] {
    return this.getCollectionFromDictionarySortedByName(DictionaryCategory.USER_STATUS)
      .map(this.dictionaryModelToStatusItem);
  }

  getAccountStatusWithoutAnonymizeItems(): SelectItem[] {
    return this.getCollectionFromDictionarySortedByName(DictionaryCategory.USER_STATUS)
      .filter(item => item.id !== AccountStatusEnum.ANONYMIZE)
      .map(this.dictionaryModelToStatusItem);
  }

  getAccountInvitationStatusItems(statuses?: AccountInvitationStatus[]): SelectItem[] {
    return this.getCollectionFromDictionarySortedByName(DictionaryCategory.INVITATION_STATUS)
      .filter(item => !statuses || statuses.indexOf(item.id as AccountInvitationStatus) > -1)
      .map(this.dictionaryModelToStatusItem);
  }

  getProposalStatusItems(statuses?: ProposalStatusTypeEnum[]): SelectItem[] {
    return this.getCollectionFromDictionarySortedByName(DictionaryCategory.PROPOSAL_STATUS)
      .filter(item => !statuses || statuses.indexOf(item.id as ProposalStatusTypeEnum) > -1)
      .map(this.dictionaryModelToStatusItem);
  }

  getSelectItems(category: DictionaryCategory): SelectItem[] {
    return this.getCollectionFromDictionarySortedByName(category)
      .map(this.dictionaryModelToStatusItem);
  }

  public mapSimpleModelToSelectItem = (simpleModel: SimpleDictionaryModel) =>
    ({
      id: simpleModel.code,
      label: simpleModel.name,
      value: simpleModel.code,
    } as SelectItem);

  private getCollectionFromDictionarySortedByName(category: DictionaryCategory): DictionaryModel[] {
    if (!this.useMultiLangDict) {
      return this.oldDictionaryService.getCollectionFromDictionarySortedByName(category);
    }
    return this.dictionaryService.getCollectionFromDictionarySortedByName(category);
  }

  private dictionaryModelToStatusItem = (dictModel: DictionaryModel) =>
    ({ id: dictModel.id, value: dictModel.id, label: dictModel.name } as SelectItem);
}
